module.exports={
  message: {
    "Account": 'Account management',
    "Home": 'Home page',
    "User listing":"User Listing",
    "Role listing":"Role permisson",
    "User list":"User Listing",
    "Role list":"Role permisson",
    "Promotion Management":"Promotion",
    "Promotion list":"Promotion Listing",
    "userName": "Search Username",
    "Status": "Status",
    "Search": "Search",
    "datagridresult": " results in total",
    "RoleName": "Role Name",
    "createdTime": "Created date",
    "Add": "Add",
    "Delete": "Delete",
    "password": "Password",
    "Tel": "Telephone",
    "email": "Email",
    "Role": "Role",
    "Active": "Active",
    "Inactive": "Inactive",
    "Save": "Save",
    "Cancel": "Cancel",
    "Confirm": "Confirm",
    "Warning": "Warning",
    "RoleType": "Role type",
    "Super Admin": "Super Admin",
    "Platform": "Platform",
    "FunctionSelection": "Function & Feature",
    "All": "--- All ---",
    "selectDefault": "--- Default ---",
    "PleaseSelect": "--- Please Select ---",
    "title": "Title",
    "LogOut": "Logout",
    "name":"Name",
    "English":"English",
    "Simplified Chinese":"Simplified Chinese",
    "Traditional Chinese":"Traditional Chinese",
    "en_US":"English",
    "zh_CN":"Simplified Chinese",
    "zh_HK":"Traditional Chinese",
    "HomePage":"Home page",
    "userDetail":"User details",
    "roleDetail":"Role details",
    "Publish":"Publish",
    "Draft":"Draft",
    "Published":"Published",
    "Preview":"Preview",
    "Edit":"Edit",
    "Landing Page Management":"Landing Page Management",
    "Account Management":"Account Management",
    "deleteContent":"Are you sure to delete the selected content?",
    "required":"This field is required",
    "Account management":"Account management",
    "fillRequired":"Please fill in the required information",
    "leaveTip":"Do you want to leave without saving changes?",
    "welcome":"Welcome to JPC CMS!",
    "Login":"Login",
    "forgetPassword":"Forgot password?",
    "Type":"Type",
    "Promotion Detail":"Promotion Detail",
    "Large Promotion Banner":"Large Promotion Banner",
    "Promotion URL":"Promotion URL",
    "Promotion Image":"Promotion Image",
    "KeyWords":"KeyWords",
    "App Preview":"App Preview",
    "Order":"Order",
    "Source Status":"Source Status",
    "Source":"Source",
    "passwordFormat": "Password should be 8 to16 characters and include at least one upper,one lower letter (s) and one number.",
    "Langing Promotion Management":"Landing Page Management",
    "Promotion Category Management":"Health Topics",
    "Promotion Category list":"Health Topics Category",
    "Promotion Keywords Management":"Popular search",
    "Promotion Keywords list":"Popular search list",
    "Promotion Category Detail":"Health Topics List ",
    "About group Management":"About GHK",
    "About group list":"Service Group List",
    "About group Detail":"Service Group Detail page",
    "Submenu Management":"Submenu Management",
    "Submenu list":"URL Management",
    "Submenu Detail":"URL Setting page",
    "Link":"Link",
    "About sub group Detail":"About sub group Detail",
    "Faq Category Management":"FAQ",
    "Faq Category list":"FAQ Category List",
    "Faq Management":"FAQ",
    "Faq list":"Faq list",
    "AE Waiting Time Management":"AE Waiting Time",
    "AE Waiting Time":"AE Waiting Time",
    "Faq group Detail":"FAQ Category Detail page",
    "Faq sub group Detail":"FAQ Question Editing Page ",
    "Terms Conditons Management":"Terms & Conditions",
    "Contact Management":"Contact Us",
    "Contact Category list":"Contact Us",
    "Section Detail":"Section Detail",
    "Sub Section Detail":"Content Detail",
    "Notification Management":"Push Notification",
    "Notification list":"Push Notification Listing",
    "Push Notification Detail":"Push Notification Detail",
    "Push Notification Listing":"Push Notification Listing",
    "Promotion SubCategory Detail":"Health Topics Detail",
    "Group Menu Management":"About GHK",
    "Group Menu list":"About GHK",
    "System":"System",
  }
}